// extracted by mini-css-extract-plugin
module.exports = {"leaveExamModal":"LeaveExamModal_leaveExamModal__2w5JY"};